var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextField } from '@mui/material';
import { useController } from 'react-hook-form';
var TextFieldControl = function (_a) {
    var name = _a.name, label = _a.label, control = _a.control, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, maxLength = _a.maxLength;
    var _d = useController({
        name: name,
        control: control,
    }), field = _d.field, error = _d.fieldState.error;
    return (_jsx(TextField, __assign({}, field, { "data-testid": name, label: label, variant: "outlined", disabled: disabled, fullWidth: true, margin: "normal", required: !disabled && required, slotProps: { htmlInput: { maxLength: maxLength } }, error: !!error, helperText: error ? error.message : '' })));
};
export default TextFieldControl;
